export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 8A8 8 0 110 8a8 8 0 0116 0zM8.667 4.587a.74.74 0 01-.74.746.739.739 0 01-.754-.746c0-.414.34-.754.754-.754.4 0 .74.334.74.754zM8 12H6.373a.669.669 0 01-.666-.667c0-.366.3-.666.666-.666h.96V8h-.96a.669.669 0 01-.666-.667c0-.366.3-.666.666-.666H8c.367 0 .667.3.667.666v3.334h.966c.367 0 .667.3.667.666a.67.67 0 01-.673.667H8z\" fill=\"#7E8391\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};